import React from "react";
import { useWebData } from "../../Context/webDataContext";
import { motion } from "framer-motion";
import img from '../../aseets/howItWorks/img1.svg';
import img2 from '../../aseets/howItWorks/img2.svg';
import img3 from '../../aseets/howItWorks/img3.svg';
import img4 from '../../aseets/howItWorks/img4.svg';

function HowItWorks() {
  const { getHowItWorksData } = useWebData();
  const data = getHowItWorksData();

  const heading = data.heading || "How It Works";
  const subtitle =
    data.subtitle ||
    "Booking a trusted professional through Maideaze is quick and easy. Just choose your service, set your schedule, and let us handle the rest!";

  const images = [img, img2, img3, img4];
  const steps = data.steps || [];

  return (
    <section className="md:py-16 py-8 bg-white" id="how-it-works">
      <div className="lg:mb-6 mb-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="md:text-4xl text-2xl font-bold text-[#08875D] md:text-left text-center"
        >
          {heading}
        </motion.h2>
      </div>

      <div className="flex flex-col md:flex-row items-start lg:gap-10 gap-4">
        {/* Left Side */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          className="w-full md:w-1/2"
        >
          <p className="text-gray-700 max-w-2xl text-sm md:text-lg md:text-left text-center">
            {subtitle}
          </p>
          {data.image && (
            <img
              src={data.image}
              alt="How It Works"
              className="rounded-xl w-full lg:max-h-[30vw] object-cover shadow-md mt-4"
            />
          )}
        </motion.div>

        {/* Right Side - Steps */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          className="w-full md:w-1/2 flex flex-col lg:gap-6 gap-3"
        >
          {steps.map((step, index) => (
            <motion.div
              key={step.id || index}
              className="flex items-start gap-4 lg:p-4 rounded-xl  hover:shadow-md transition-shadow duration-300"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              {/* Step Image */}
              <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16">
                <img
                  src={images[index % images.length]}
                  alt={`Step ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Step Text */}
              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-1">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default HowItWorks;
